import * as React from 'react';

import socialIconSetMap from './iconSvgMap';
import socialIconNames from './iconNames';
import { IconSet, IBaseIconSet } from '../icon-set/IconSet';

const SocialIconSet = (props: IBaseIconSet) => {
    return <IconSet iconSetMap={socialIconSetMap} {...props} />;
};

export { SocialIconSet, socialIconNames };
